/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaButtonWithText/view.blocks to change it.
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function TysiaButtonWithText({
  children,
  viewPath = "/DesignSystem/TysiaButtonWithText",
  justifyContent,
  marginLeft,
  marginRight,
  marginTop,
  marginBottom,
  onClick,
  disabled,
  stopPropagation,
  type,
  size,
  height,
  width,
  innerRef,
  alignSelf,
  color,
  text
  
}) {
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 justifyContent={justifyContent}
 marginLeft={marginLeft}
 marginRight={marginRight}
 marginTop={marginTop}
 marginBottom={marginBottom}
 onClick={onClick}
 disabled={disabled}
 stopPropagation={stopPropagation}
 type={type}
 size={size}
 height={height}
 width={width}
 innerRef={innerRef}
 alignSelf={alignSelf}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 color={color}
 text={text}
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}